module.exports = __webpack_public_path__ + "fonts/regular.f01e9ae.woff";